import React, { useEffect, useState } from 'react';
import axios from 'axios';
import EmbeddedModule from './EmbeddedModule';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SECTIONS = [
  'India GRC TAM',
  'AI Governance Mandates 2026',
  'BFSI Cyber Investments',
  'DPDP Spend Outlook',
  'AML / FRM Convergence',
  'VDA Compliance Frontier',
  'Reg-Tech IPO Pipeline',
  'Top-15 Banks Risk Map',
  'NBFC-UL Tier-1 Spend',
  'Cross-Border Corridor Risk',
  'Cybersecurity Talent Index',
  'India Reg-Tech Unicorn Watch',
  'Procurement Benchmarks',
  'Vendor Concentration Index',
  '2027 Outlook'
];

const StrategicIntelligence = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/intelligence/brief`).then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  return (
    <EmbeddedModule
      eyebrow="C-Suite Brief · April 2026"
      title="Strategic Intelligence 2026"
      tagline={data?.tagline || '$1 Billion Intelligence Brief on India\'s GRC–AI–FinTech Frontier.'}
      badgeText={data?.edition || 'April 2026'}
      accentClass="from-blue-900 via-indigo-800 to-violet-800"
      embedUrl="https://sanmig-march.replit.app"
      embedTitle="sanmig-march.replit.app"
      testId="strategic-intelligence-page"
      kpis={[
        { label: 'India GRC TAM', value: data ? `₹${data.headline_metrics.tam_inr_cr.toLocaleString()} Cr` : '—' },
        { label: 'Compliance Spend', value: data?.headline_metrics.compliance_spend_growth || '—' },
        { label: 'AI Mandates 2026', value: data?.headline_metrics.ai_governance_mandates_2026 || '—' },
        { label: 'Circulars (30d)', value: data?.headline_metrics.tracked_circulars_last_30d || '—' }
      ]}
    >
      <Card data-testid="strategic-sections">
        <CardHeader>
          <CardTitle>15 Sections in this Edition</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {SECTIONS.map((s, i) => (
              <div
                key={s}
                className="border border-gray-200 rounded-md px-3 py-2.5 bg-white text-sm text-gray-800 hover:border-indigo-300 transition-colors flex items-center gap-2"
              >
                <Badge variant="outline" className="text-[10px]">{(i + 1).toString().padStart(2, '0')}</Badge>
                {s}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </EmbeddedModule>
  );
};

export default StrategicIntelligence;
